const sseEventSource = (state) => state.sseEventSource;
const sseResponseData = (state) => state.sseResponseData;
const isSseEventSourceClosed = (state) => state.isSseEventSourceClosed;
const lastEventId = (state) => state.lastEventId;

export default {
    sseEventSource,
    lastEventId,
    sseResponseData,
    isSseEventSourceClosed,
};



// WEBPACK FOOTER //
// ./src/store/modules/sse/getters.js